/* es5-ext/object/valid-value.js */ function _(require, module, exports) {
    var isValue = require(8) /* ./is-value */;
    module.exports = function (value) {
        if (!isValue(value))
            throw new TypeError("Cannot use null or undefined");
        return value;
    };
}
